module.exports = __webpack_public_path__ + "static/img/11.cec39588.png";